import ResponsiveContentWrapper from "../components/layout/ResponsiveContentWrapper";
import SmartRoomDashboard from "../components/smartRoomDashboard";

const SmartRoomDashboardPage = () => (
  <ResponsiveContentWrapper>
    <SmartRoomDashboard />
  </ResponsiveContentWrapper>
);

export default SmartRoomDashboardPage;
